"use client";

/** 密码强度评估 + 可视化条。 */
export function passwordScore(pw: string): { score: 0 | 1 | 2 | 3; label: string } {
  if (!pw) return { score: 0, label: "" };
  let s = 0;
  if (pw.length >= 8) s++;
  if (pw.length >= 12) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw) && /[^a-zA-Z0-9]/.test(pw)) s++;
  if (s >= 3) return { score: 3, label: "强" };
  if (s === 2) return { score: 2, label: "中" };
  return { score: 1, label: "弱" };
}

const COLORS = ["bg-transparent", "bg-red-500", "bg-amber-500", "bg-emerald-500"];

export function PasswordStrength({ password }: { password: string }) {
  const { score, label } = passwordScore(password);
  if (!password) return null;
  return (
    <div className="flex items-center gap-2" data-clarity-mask="true">
      <div className="flex gap-1 flex-1">
        {[1, 2, 3].map((i) => (
          <div
            key={i}
            className={`h-1 flex-1 rounded-full transition-colors ${i <= score ? COLORS[score] : "bg-muted"}`}
          />
        ))}
      </div>
      <span className="text-xs text-muted-foreground w-6 text-right">{label}</span>
    </div>
  );
}
